import styled from 'styled-components'

export const StyledContainer = styled.div`
  margin-bottom: 0px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin-bottom: 0px;
  }
`
